import React, { useState } from 'react';
import StatusBar from '../components/common/StatusBar';
import Cart from '../components/common/Cart';

// Composants spécifiques services (à créer plus tard)
const ServiceBuilder = () => {
  const services = [
    { id: 1, name: 'Coupe Homme', price: 25.00, duration: '30 min', category: 'Coiffure' },
    { id: 2, name: 'Coupe Femme', price: 35.00, duration: '45 min', category: 'Coiffure' },
    { id: 3, name: 'Coloration', price: 65.00, duration: '90 min', category: 'Coloration' },
    { id: 4, name: 'Mèches', price: 45.00, duration: '60 min', category: 'Coloration' },
    { id: 5, name: 'Lissage', price: 55.00, duration: '75 min', category: 'Soins' },
    { id: 6, name: 'Permanente', price: 75.00, duration: '120 min', category: 'Soins' },
  ];

  const categories = ['Tous', ...new Set(services.map(s => s.category))];
  const [selectedCategory, setSelectedCategory] = useState('Tous');

  const filteredServices = selectedCategory === 'Tous' 
    ? services 
    : services.filter(s => s.category === selectedCategory);

  return (
    <div className="bg-white rounded-lg shadow-sm border h-full flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold text-gray-800">Services</h3>
          <button className="px-3 py-1 bg-blue-500 text-white rounded-lg text-sm hover:bg-blue-600">
            + Ajouter
          </button>
        </div>
        
        {/* Filtres par catégorie */}
        <div className="flex gap-2 overflow-x-auto pb-2">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-3 py-1 text-sm rounded-full whitespace-nowrap transition-colors ${
                selectedCategory === category
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
      
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="grid grid-cols-2 gap-3">
          {filteredServices.map((service) => (
            <div
              key={service.id}
              className="bg-gray-50 rounded-lg p-3 cursor-pointer hover:bg-blue-50 transition-colors border"
            >
              <div className="text-center">
                <div className="text-2xl mb-2">💇‍♀️</div>
                <h4 className="font-medium text-sm text-gray-800 mb-1">{service.name}</h4>
                <p className="text-xs text-gray-500 mb-2">{service.category}</p>
                <div className="flex items-center justify-between mb-2">
                  <div className="text-lg font-bold text-green-600">{service.price.toFixed(2)} €</div>
                  <div className="text-xs text-gray-500">{service.duration}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ClientSelector = () => {
  const clients = [
    { id: 1, name: 'Marie Dupont', phone: '06 12 34 56 78', lastVisit: '2024-01-15' },
    { id: 2, name: 'Jean Martin', phone: '06 98 76 54 32', lastVisit: '2024-01-10' },
    { id: 3, name: 'Sophie Bernard', phone: '06 11 22 33 44', lastVisit: '2024-01-20' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border h-full flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold text-gray-800">Client</h3>
          <button className="px-3 py-1 bg-green-500 text-white rounded-lg text-sm hover:bg-green-600">
            + Nouveau
          </button>
        </div>
        <input
          type="text"
          placeholder="Rechercher un client..."
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-2">
          {clients.map((client) => (
            <div
              key={client.id}
              className="p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-blue-50 transition-colors border"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-semibold">
                  {client.name.charAt(0)}
                </div>
                <div className="flex-1">
                  <div className="font-medium text-sm text-gray-800">{client.name}</div>
                  <div className="text-xs text-gray-500">{client.phone}</div>
                  <div className="text-xs text-gray-400">Dernière visite: {client.lastVisit}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const TimeTracker = () => {
  const [isRunning, setIsRunning] = useState(false);
  const [time, setTime] = useState(0);

  const startTimer = () => {
    setIsRunning(true);
    // TODO: Implémenter le timer
  };

  const stopTimer = () => {
    setIsRunning(false);
    // TODO: Arrêter le timer
  };

  const resetTimer = () => {
    setTime(0);
    setIsRunning(false);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border">
      <div className="p-4 border-b bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-800">Chronomètre</h3>
      </div>
      <div className="p-4">
        <div className="text-center mb-4">
          <div className="text-3xl font-mono text-gray-800 mb-2">
            {formatTime(time)}
          </div>
          <div className="text-sm text-gray-500">Temps de service</div>
        </div>
        
        <div className="flex gap-2">
          <button
            onClick={isRunning ? stopTimer : startTimer}
            className={`flex-1 py-2 rounded-lg font-medium transition-colors ${
              isRunning 
                ? 'bg-red-500 text-white hover:bg-red-600' 
                : 'bg-green-500 text-white hover:bg-green-600'
            }`}
          >
            {isRunning ? 'Arrêter' : 'Démarrer'}
          </button>
          <button
            onClick={resetTimer}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

const AppointmentList = () => {
  const appointments = [
    { id: 1, client: 'Marie Dupont', service: 'Coupe Femme', time: '14:00', status: 'confirmed' },
    { id: 2, client: 'Jean Martin', service: 'Coupe Homme', time: '15:30', status: 'pending' },
    { id: 3, client: 'Sophie Bernard', service: 'Coloration', time: '17:00', status: 'confirmed' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border h-full flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-800">Rendez-vous</h3>
      </div>
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-2">
          {appointments.map((appointment) => (
            <div
              key={appointment.id}
              className={`p-3 rounded-lg border ${
                appointment.status === 'confirmed' 
                  ? 'bg-green-50 border-green-200' 
                  : 'bg-yellow-50 border-yellow-200'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium text-sm text-gray-800">{appointment.client}</div>
                  <div className="text-xs text-gray-600">{appointment.service}</div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-semibold text-gray-800">{appointment.time}</div>
                  <div className={`text-xs px-2 py-1 rounded-full ${
                    appointment.status === 'confirmed' 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-yellow-100 text-yellow-700'
                  }`}>
                    {appointment.status === 'confirmed' ? 'Confirmé' : 'En attente'}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ServicesLayout = ({ 
  // États
  commandes,
  currentCommande,
  selectedLineIndex,
  currentCommandeIndex,
  
  // Fonctions
  addProductToCurrentCommande,
  setSelectedLineIndex,
  updateItemQuantity,
  removeItemFromCommande,
  clearCurrentCommande,
  createNewCommande,
  switchToCommande,
  saveSale,
  handlePaymentComplete
}) => {
  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Barre de statut avec infos client */}
      <div className="bg-white border-b border-gray-200">
        <StatusBar />
        <div className="px-4 py-2 bg-blue-50 border-b">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-blue-700">Client sélectionné:</span>
            <span className="text-sm text-blue-600">Marie Dupont</span>
          </div>
        </div>
      </div>
      
      {/* Contenu principal */}
      <div className="flex-1 flex gap-4 p-4 overflow-hidden">
        {/* Colonne gauche - Services et Client */}
        <div className="flex-1 flex flex-col gap-4">
          {/* Services */}
          <div className="flex-1">
            <ServiceBuilder />
          </div>
          
          {/* Client et Rendez-vous */}
          <div className="flex gap-4 h-80">
            <div className="flex-1">
              <ClientSelector />
            </div>
            <div className="flex-1">
              <AppointmentList />
            </div>
          </div>
        </div>
        
        {/* Colonne droite - Chronomètre et Panier */}
        <div className="w-96 flex flex-col gap-4">
          {/* Chronomètre */}
          <div className="h-48">
            <TimeTracker />
          </div>
          
          {/* Panier */}
          <div className="flex-1">
            <Cart 
              layoutType="services"
              commandes={commandes}
              currentCommande={currentCommande}
              selectedLineIndex={selectedLineIndex}
              currentCommandeIndex={currentCommandeIndex}
              addProductToCurrentCommande={addProductToCurrentCommande}
              setSelectedLineIndex={setSelectedLineIndex}
              updateItemQuantity={updateItemQuantity}
              removeItemFromCommande={removeItemFromCommande}
              clearCurrentCommande={clearCurrentCommande}
              createNewCommande={createNewCommande}
              switchToCommande={switchToCommande}
              onSaveSale={saveSale}
              onPaymentComplete={handlePaymentComplete}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesLayout; 